import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from 'src/app/user/user.service';
import { CaseActionComponent } from 'src/app/user/profile/case-action/case-action.component';
import { ResourcesService } from 'src/app/resources/resources.service';
import { TranslateOrgSpecificPipe } from '../pipes/translate-org-specific.pipe';
import { NotifierService } from 'angular-notifier';
import { AddNotesPopupComponent } from 'src/app/user/profile/add-notes-popup/add-notes-popup.component';
import { Constants } from 'src/app/app.constants';
import { NewCaseComponent } from '../new-case/new-case.component';

@Component({
  selector: 'app-participant-profile-view',
  templateUrl: './participant-profile-view.component.html',
  styleUrls: ['./participant-profile-view.component.css']
})

export class ParticipantProfileViewComponent implements OnInit {
  @Input() participantId: number;
  modalOption: NgbModalOptions = {};
  selectedIndex = 0;
  patientId = 0;
  patientDetails: any;
  fullName: string;
  age: number;
  gender: string;
  caseDetailsList: any[] = [];
  caseDetails: any[] = [];
  caseName: string;
  caseCode: string;
  caseNotes: any[] = [];
  caseId = 0;
  countyId: number;
  assistanceHistory: any[] = [];
  userDoclist: any[] = [];
  deleteConfirm = false;
  itemTobeDeleted: any;
  closeConfirm = false;
  caseTobeClosed: any;
  isButtonDisabled = false;
  constructor(private userService: UserService,
    private resourceService: ResourcesService
    , private notifier: NotifierService
    , private translateOrgSpecific: TranslateOrgSpecificPipe,
    private modalService: NgbModal
  ) { }


  ngOnInit() {

    if (this.patientId == 0 || this.patientId == null || this.patientId == undefined) {
      this.patientId = this.participantId;
    }

    this.getParicipantDetails();
    this.getParicipantCaseDetails();
    this.getLibraryDocsList();
  }
  getLibraryDocsList() {
    this.resourceService.getLibraryDocsList(this.patientId).subscribe((list: any) => {
      if (list) {
        this.userDoclist = list;
      }
    });
  }
  getParicipantDetails() {
    this.userService.getParicipantDetails(this.patientId).subscribe((result: any) => {
      if (result) {
        if (result.questionAndAnswer.length > 0) {

        }

        this.patientDetails = result;
        this.fullName = result.firstName + ' ' + result.lastName;
        this.age = result.age;
        this.gender = result.gender;
      }
    });
  }


  getParicipantCaseDetails() {
    this.userService.getParicipantCaseDetails(this.patientId).subscribe((result: any) => {
      if (result.length != 0) {
        this.caseDetailsList = result;
        this.caseDetailsList.forEach(element => {
          const temp = new Date(element.create_ts).toLocaleString('en-US');
          element.create_ts = new Date(temp + ' UTC');
          if (element.assistanceHistory) {
            element.assistanceHistory.forEach(ele => {
              const tempdt = new Date(ele.createTs).toLocaleString('en-US');
              ele.createTs = new Date(tempdt + ' UTC');
            });
          }
          if (element.notesArray) {
            element.notesArray.forEach(el => {
              const tempdt = new Date(el.noteDate).toLocaleString('en-US');
              el.noteDate = new Date(tempdt + ' UTC');
            });
          }
        });
        this.initialTabData(this.selectedIndex);
      }
    });
  }

  initialTabData(i) {
    this.caseDetails = this.caseDetailsList[i].questionAndAnswer;
    this.caseCode = this.caseDetailsList[i].case_number;
    this.caseName = this.caseDetailsList[i].issueCategoryName;
    this.caseNotes = this.caseDetailsList[i].notesArray;
    if (this.caseDetailsList[i].assistanceHistory && this.caseDetailsList[i].assistanceHistory.length > 0) {
      this.assistanceHistory = this.caseDetailsList[i].assistanceHistory;
    }
    this.caseId = this.caseDetailsList[i].case_id;
    this.countyId = this.caseDetailsList[i].county_id;
    this.isButtonDisabled = this.caseDetailsList[i].caseStatus == Constants.Closed ? true : false;

  }
  onClick(index, data) {
    this.selectedIndex = index;
    if (data.questionAndAnswer) {
      this.caseDetails = data.questionAndAnswer;
      this.caseCode = data.case_number;
      this.caseName = data.issueCategoryName;
      this.caseNotes = data.notesArray;
      this.assistanceHistory = data.assistanceHistory;
      this.caseId = data.case_id;
      this.countyId = data.county_id;
    }
    this.isButtonDisabled = data.caseStatus == Constants.Closed ? true : false;
  }


  delete() {
    this.resourceService.deleteLibraryResources(this.itemTobeDeleted.clientDocumentId, this.itemTobeDeleted.docUrl).subscribe(
      (data: any) => {
        this.getLibraryDocsList();


        this.notifier.notify('success', this.translateOrgSpecific.transform('LibraryDocsDeleteed'));
        this.getLibraryDocsList();

      });
    this.deleteConfirm = false;

  }
  confirmDelete(deleteData) {
    this.deleteConfirm = true;
    this.itemTobeDeleted = deleteData;
  }
  cancelDelete() {
    this.deleteConfirm = false;
  }
  addNotes() {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalOption.size = 'lg';
    this.modalOption.windowClass = 'invitestyle';
    const dialogRef = this.modalService.open(AddNotesPopupComponent, this.modalOption);
    dialogRef.componentInstance.casedata = { caseName: this.caseName, caseCode: this.caseCode, participantname: this.fullName, age: this.age, gender: this.gender, caseId: this.caseId };
    dialogRef.result.then((result) => {
      this.refreshCaseList(this.caseId);
      this.getParicipantCaseDetails();
    });
  }


  //


  openCase() {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalOption.size = 'lg';
    this.modalOption.windowClass = 'invitestyle';
    const dialogRef = this.modalService.open(NewCaseComponent, this.modalOption);
    dialogRef.componentInstance.data = { participantId: this.patientId, caseId: 0 };
    dialogRef.result.then((result) => {
      this.selectedIndex = 0;
      this.getParicipantCaseDetails();
    });
  }
  EditCase(code) {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalOption.size = 'lg';
    this.modalOption.windowClass = 'invitestyle';
    const dialogRef = this.modalService.open(NewCaseComponent, this.modalOption);
    dialogRef.componentInstance.data = { participantId: 0, caseId: this.caseId };
    dialogRef.result.then((result) => {
      this.getParicipantCaseDetails();
    });
  }


  close() {
    this.userService.closeCase(this.caseId).subscribe(
      (data: any) => {
        if (data.status == Constants.Closed) {
          this.notifier.notify('success', this.translateOrgSpecific.transform('CaseClosedSuccessfully'));
          this.caseDetailsList[this.selectedIndex].caseStatus = data.status;
          this.isButtonDisabled = true;
          this.closeConfirm = false;
        } else if (data.status == Constants.ExistsAppointment) {
          this.notifier.notify('error', this.translateOrgSpecific.transform('CaseCloseErrMsgFromAppt'));
          this.closeConfirm = false;
        } else if (data.status == Constants.ExistsWaitingRoom) {
          this.notifier.notify('error', this.translateOrgSpecific.transform('CaseCloseErrMsgFromWaiting'));
          this.closeConfirm = false;
        }
      });
  }
  closeCase() {
    this.closeConfirm = true;
  }
  cancelClose() {
    this.closeConfirm = false;
  }

  refreshCaseList(caseId) {
    this.userService.refreshCaseNoteList(caseId).subscribe((result: any) => {
      if (result) {
        this.caseNotes = result;
        this.caseNotes.forEach(element => {
          const temp = new Date(element.noteDate).toLocaleString('en-US');
          element.noteDate = new Date(temp + ' UTC');
        });
        this.caseDetailsList[this.selectedIndex].notesArray = this.caseNotes;
      }
    });
  }


  addAction() {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalOption.size = 'lg';
    this.modalOption.windowClass = 'invitestyle';
    const dialogRef = this.modalService.open(CaseActionComponent, this.modalOption);
    dialogRef.componentInstance.casedata = { caseName: this.caseName, caseCode: this.caseCode, participantname: this.fullName, age: this.age, gender: this.gender, caseId: this.caseId, countyId: this.countyId };
    dialogRef.result.then((result) => {
      if (result && result.caseActionId) {
        this.notifier.notify('success', this.translateOrgSpecific.transform('AssistanceSavedSuccessfully'));
        this.getParicipantCaseDetails();
      }
    });
  }




  //



}
